import ParagraphTypeAdaAdSlot from '../ad-slots/AdaAdSlot.vue'
import AdaSlotMarker from '../ad-slots/AdaSlotMarker.vue'
import ParagraphTypeAdaNativeCrossbar from '../ad-slots/AdaNativeCrossbar.vue'
import ParagraphTypeAdaAutoNative from '../ad-slots/AdaAutoNative.vue'
import ParagraphTypeAdaPagestrip from '../ad-slots/AdaPagestrip.vue'
import ParagraphTypeTeaserGroup from '../teaser/TeaserGroup.vue'
import ParagraphTypeAffiliateLink from './ParagraphTypeAffiliateLink.vue'
import ParagraphTypeHorizontalLine from './ParagraphTypeHorizontalLine.vue'
import ParagraphTypeHtml from './ParagraphTypeHtml.vue'
import ParagraphTypeImage from './ParagraphTypeImage.vue'
import ParagraphTypeInterline from './ParagraphTypeInterline.vue'
import ParagraphTypeRelatedTags from './ParagraphTypeRelatedTags.vue'
import { asyncParagraphType } from './async-paragraph-type'

// Async paragraph types
const ParagraphTypeAuthorBox = asyncParagraphType('AuthorBox', { deferPreload: true })
const ParagraphTypeChildTagsTeaserGroup = asyncParagraphType('ChildTagsTeaserGroup', {
  deferPreload: true,
  loader: () => import('../teaser/ChildTagsTeaserGroup.vue'),
  hydrateBeforeVisible: true,
  modulePath: 'components/teaser/ChildTagsTeaserGroup.vue'
})
const ParagraphTypeContentBox = asyncParagraphType('ContentBox', { deferPreload: true })
// Client-only embeds render as comments during SSR, leaving hydrateOnVisible without an observable element.
const ParagraphTypeEmbed = asyncParagraphType('Embed', { deferPreload: true, deferHydration: false })
const ParagraphTypeIframe = asyncParagraphType('Iframe', {
  deferPreload: true,
  loader: () => import('./ParagraphTypeIframe/EmbedWrapper.vue'),
  modulePath: 'components/paragraph-types/ParagraphTypeIframe/EmbedWrapper.vue'
})
const ParagraphTypeInlineTeaser = asyncParagraphType('InlineTeaser', {
  deferPreload: true,
  loader: () => import('../teaser/InlineTeaser.vue'),
  modulePath: 'components/teaser/InlineTeaser.vue'
})
const ParagraphTypeListOfSources = asyncParagraphType('ListOfSources', { deferPreload: true })
const ParagraphTypeSlider = asyncParagraphType('Slider', { deferPreload: true, hydrateBeforeVisible: true })
const ParagraphTypeSocialStrip = asyncParagraphType('SocialStrip', { deferPreload: true })
const ParagraphTypeTable = asyncParagraphType('Table', { deferPreload: true })
const ParagraphTypeRecipe = asyncParagraphType('Recipe', {
  loader: () => import('./ParagraphTypeRecipe/RecipeWrapper.vue'),
  modulePath: 'components/paragraph-types/ParagraphTypeRecipe/RecipeWrapper.vue'
})
const ParagraphTypeVideo = asyncParagraphType('Video', { hydrateBeforeVisible: true })
const ParagraphTypeEpgWidget = asyncParagraphType('EpgWidget')
const ParagraphTypeAdditionalLinks = asyncParagraphType('AdditionalLinks')
const ParagraphTypeAdDividingLine = asyncParagraphType('AdDividingLine')
const ParagraphTypeAscendantCalculator = asyncParagraphType('AscendantCalculator')
const ParagraphTypeButtonGroup = asyncParagraphType('ButtonGroup')
const ParagraphTypeContactForm = asyncParagraphType('ContactForm')
const ParagraphTypeEpgBroadcastRating = asyncParagraphType('EpgBroadcastRating')
const ParagraphTypeEpgBroadcastReruns = asyncParagraphType('EpgBroadcastReruns')
const ParagraphTypeFaq = asyncParagraphType('Faq')
const ParagraphTypeFileDownload = asyncParagraphType('FileDownload')
const ParagraphTypeHoroscope = asyncParagraphType('Horoscope')
const ParagraphTypeHotOrNot = asyncParagraphType('HotOrNot')
const ParagraphTypeInfoBar = asyncParagraphType('InfoBar')
const ParagraphTypeLexicon = asyncParagraphType('Lexicon')
const ParagraphTypeLogoSlider = asyncParagraphType('LogoSlider')
const ParagraphTypeMoonRun = asyncParagraphType('MoonRun')
const ParagraphTypeNewsletterTeaser = asyncParagraphType('NewsletterTeaser')
const ParagraphTypePoll = asyncParagraphType('Poll')
const ParagraphTypeProductAutoComparison = asyncParagraphType('ProductAutoComparison')
const ParagraphTypeProductGroup = asyncParagraphType('ProductGroup')
const ParagraphTypeQuote = asyncParagraphType('Quote')
const ParagraphTypeSearch = asyncParagraphType('Search')
const ParagraphTypeStructureTermTree = asyncParagraphType('StructureTermTree')
const ParagraphTypeTabbedInfo = asyncParagraphType('TabbedInfo')
const ParagraphTypeTableExt = asyncParagraphType('TableExt')
const ParagraphTypeTableOfContents = asyncParagraphType('TableOfContents')
const ParagraphTypeVodEpgBroadcastSlider = asyncParagraphType('VodEpgBroadcastSlider')
const ParagraphTypeVodRating = asyncParagraphType('VodRating')
const ParagraphTypeVodStreamingCard = asyncParagraphType('VodStreamingCard')
const ParagraphTypeVodStreamingOptions = asyncParagraphType('VodStreamingOptions')
const ParagraphTypeVodSeasonWithEpisodes = asyncParagraphType('VodSeasonWithEpisodes')
const ParagraphTypeVodTeaserForEpgBroadcast = asyncParagraphType('VodTeaserForEpgBroadcast')
const ParagraphTypeWebForm = asyncParagraphType('WebForm')
const ParagraphTypeCarOfferWidget = asyncParagraphType('CarOfferWidget')
const ParagraphTypeRecipeAggregateRating = asyncParagraphType('RecipeAggregateRating')
const ParagraphTypeVerticalVideo = asyncParagraphType('VerticalVideo')

// Async components
const ParagraphTypeUserActivation = asyncParagraphType('UserActivation', { component: true })
const ParagraphTypeUserPasswordChange = asyncParagraphType('UserPasswordChange', { component: true })
const ParagraphTypeUserPasswordReset = asyncParagraphType('UserPasswordReset', { component: true })
const ParagraphTypeUserLogin = asyncParagraphType('UserLogin', { component: true })
const ParagraphTypeUserRegister = asyncParagraphType('UserRegister', { component: true })
const ParagraphTypeUserSubscription = asyncParagraphType('UserSubscription', { component: true })

export {
  ParagraphTypeHtml,
  ParagraphTypeInterline,
  ParagraphTypeImage,
  ParagraphTypeQuote,
  ParagraphTypeSlider,
  ParagraphTypeSocialStrip,
  ParagraphTypeVideo,
  ParagraphTypeVerticalVideo,
  ParagraphTypeWebForm,
  ParagraphTypeAdaNativeCrossbar,
  ParagraphTypeAdaAdSlot,
  ParagraphTypeAdaAutoNative,
  ParagraphTypeAdaPagestrip,
  ParagraphTypeEmbed,
  ParagraphTypeFaq,
  ParagraphTypeIframe,
  ParagraphTypeHorizontalLine,
  ParagraphTypeRelatedTags,

  ParagraphTypeInlineTeaser,
  ParagraphTypeTeaserGroup,
  ParagraphTypeChildTagsTeaserGroup,
  ParagraphTypeStructureTermTree,
  ParagraphTypeAuthorBox,
  ParagraphTypeContentBox,
  ParagraphTypeAffiliateLink,
  ParagraphTypeAdditionalLinks,
  ParagraphTypeListOfSources,
  ParagraphTypeMoonRun,
  ParagraphTypeTable,
  ParagraphTypeTableExt,
  ParagraphTypeTableOfContents,
  ParagraphTypeHotOrNot,
  ParagraphTypePoll,
  ParagraphTypeNewsletterTeaser,
  ParagraphTypeAscendantCalculator,
  ParagraphTypeHoroscope,
  ParagraphTypeButtonGroup,
  ParagraphTypeFileDownload,
  ParagraphTypeProductGroup,
  ParagraphTypeLexicon,
  ParagraphTypeSearch,
  ParagraphTypeContactForm,
  ParagraphTypeUserRegister,
  ParagraphTypeUserLogin,
  ParagraphTypeUserActivation,
  ParagraphTypeUserPasswordReset,
  ParagraphTypeUserPasswordChange,
  ParagraphTypeUserSubscription,
  ParagraphTypeRecipe,
  ParagraphTypeProductAutoComparison,
  ParagraphTypeInfoBar,
  ParagraphTypeVodRating,
  ParagraphTypeVodStreamingCard,
  ParagraphTypeVodStreamingOptions,
  ParagraphTypeVodSeasonWithEpisodes,
  ParagraphTypeEpgBroadcastRating,
  ParagraphTypeEpgBroadcastReruns,
  ParagraphTypeLogoSlider,
  ParagraphTypeEpgWidget,
  ParagraphTypeVodTeaserForEpgBroadcast,
  ParagraphTypeAdDividingLine,
  ParagraphTypeTabbedInfo,
  ParagraphTypeVodEpgBroadcastSlider,
  AdaSlotMarker,
  ParagraphTypeCarOfferWidget,
  ParagraphTypeRecipeAggregateRating
}

export default {
  ParagraphTypeHtml,
  ParagraphTypeInterline,
  ParagraphTypeImage,
  ParagraphTypeQuote,
  ParagraphTypeSlider,
  ParagraphTypeVideo,
  ParagraphTypeWebForm,
  ParagraphTypeAdaNativeCrossbar,
  ParagraphTypeAdaAdSlot,
  ParagraphTypeAdaAutoNative,
  ParagraphTypeAdaPagestrip,
  ParagraphTypeEmbed,
  ParagraphTypeFaq,
  ParagraphTypeIframe,
  ParagraphTypeHorizontalLine,
  ParagraphTypeRelatedTags,
  ParagraphTypeInlineTeaser,
  ParagraphTypeTeaserGroup,
  ParagraphTypeChildTagsTeaserGroup,
  ParagraphTypeStructureTermTree,
  ParagraphTypeAuthorBox,
  ParagraphTypeContentBox,
  ParagraphTypeAffiliateLink,
  ParagraphTypeAdditionalLinks,
  ParagraphTypeListOfSources,
  ParagraphTypeMoonRun,
  ParagraphTypeTable,
  ParagraphTypeTableExt,
  ParagraphTypeTableOfContents,
  ParagraphTypeHotOrNot,
  ParagraphTypePoll,
  ParagraphTypeNewsletterTeaser,
  ParagraphTypeAscendantCalculator,
  ParagraphTypeHoroscope,
  ParagraphTypeButtonGroup,
  ParagraphTypeFileDownload,
  ParagraphTypeProductGroup,
  ParagraphTypeLexicon,
  ParagraphTypeSearch,
  ParagraphTypeContactForm,
  ParagraphTypeUserRegister,
  ParagraphTypeUserLogin,
  ParagraphTypeUserActivation,
  ParagraphTypeUserPasswordReset,
  ParagraphTypeUserPasswordChange,
  ParagraphTypeUserSubscription,
  ParagraphTypeRecipe,
  ParagraphTypeProductAutoComparison,
  ParagraphTypeInfoBar,
  ParagraphTypeVodRating,
  ParagraphTypeVodStreamingCard,
  ParagraphTypeVodStreamingOptions,
  ParagraphTypeVodSeasonWithEpisodes,
  ParagraphTypeEpgBroadcastRating,
  ParagraphTypeEpgBroadcastReruns,
  ParagraphTypeLogoSlider,
  ParagraphTypeEpgWidget,
  ParagraphTypeVodTeaserForEpgBroadcast,
  ParagraphTypeAdDividingLine,
  ParagraphTypeTabbedInfo,
  ParagraphTypeVodEpgBroadcastSlider,
  AdaSlotMarker,
  ParagraphTypeCarOfferWidget,
  ParagraphTypeRecipeAggregateRating,
  ParagraphTypeVerticalVideo
}
